import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousin.module.scss";

function PageCousin() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p29", "png");
  const pointer = getImgSet("pointer__cousin", "png", s.pointer);

  const back = getImgSet("back__p21", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);
  const imgB = getImgSet("bear__05__alt", "png", s.img__b);
  const imgC = getImgSet("img__p29", "png", s.img__c);
  const description = getImgSet("description__p29", "png", s.description);
  const quizBtn = getImgSet("button__quiz", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/" className={s.back}>
          {back}
        </Link>
        <div className={s.bears}>
          {imgA}
          {imgB}
        </div>
      </div>
      <div className={s.inner}>
        <div className={s.cols}>
          {description}
          {imgC}
        </div>
        <Link to="a" className={cn(s.item, s.item__01)}>
          {item01}
        </Link>
      </div>
      <div className={s.aside_right}>
        <Link to="/cousin/quiz" className={s.button__quiz}>
          {quizBtn}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageCousin, false, true, true);
